import { NgIf, AsyncPipe, CommonModule } from '@angular/common'
import { Component, HostBinding, OnInit } from '@angular/core'
import { CmsComponentData, GenericLinkComponent, GenericLinkModule } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { EbResponsiveMediaComponent } from '../responsive-media/eb-responsive-media.component'
import { EbButtonComponent } from './eb-button.interface'

@Component({
  selector: 'eb-button',
  templateUrl: './eb-cms-button.component.html',
  styleUrls: ['./eb-cms-button.component.scss'],
  standalone: true,
  imports: [NgIf, GenericLinkComponent, AsyncPipe]
})
export class EbCmsButtonComponent implements OnInit {
  @HostBinding('style.textAlign') alignment: string

  protected data$: Observable<EbButtonComponent>

  constructor(protected component: CmsComponentData<EbButtonComponent>) {
    this.data$ = this.component.data$
  }

  getTarget(data: EbButtonComponent): string | null {
    return data.externalLink === 'true' || data.externalLink === true ? '_blank' : null
  }

  ngOnInit() {
    this.data$.pipe(take(1)).subscribe(data => (this.alignment = data.alignment))
  }
}
